import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { AddToCartComponent } from '@spartacus/cart/base/components/add-to-cart';
import { CmsAddToCartComponent, EventService, Product, User } from '@spartacus/core';
import { CmsComponentData, CurrentProductService, LaunchDialogService } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { UigActiveCartService } from 'src/app/services/uig-active-cart.service';
import { UigShopViewService } from 'src/app/services/uig-shop-view.service';
import { UigCartUiEventAddToCart } from '../uig-cart.models';

@Component({
    selector: 'app-uig-add-to-cart',
    templateUrl: './uig-add-to-cart.component.html',
    styleUrls: ['./uig-add-to-cart.component.scss'],
    standalone: false
})
export class UigAddToCartComponent extends AddToCartComponent implements OnDestroy {

  product: Product;
  isRestricted = false;
  RIO_CART_ORDER = 'rio_cart_order';
  RIO_CART_CREATE_UPDATE = 'rio_cart_create_update';
  hasShopViewUserRole = true;
  roles: string[];
  private userSubscription = new Subscription();
  private numberOfEntriesBeforeAdd: any;

  constructor(
      protected launchDialogService: LaunchDialogService,
      protected currentProductService: CurrentProductService,
      cd: ChangeDetectorRef,
      protected activeCartService: UigActiveCartService,
      private userAccountFacade: UserAccountFacade,
      private uigShopViewService: UigShopViewService,
      component: CmsComponentData<CmsAddToCartComponent>,
      eventService: EventService
  ) {
    super( currentProductService, cd, activeCartService, component, eventService);
    this.uigShopViewService.isShopViewMode().subscribe((hasRole) => {
      this.hasShopViewUserRole = hasRole;
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.currentProductService
      .getProduct()
      .pipe(filter(Boolean))
      .subscribe((product) => {
        this.product = product;
        this.addToCartForm.setValue({quantity: 1});
      });
    this.checkForRoles();
  }
  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }

  protected createCartUiEventAddToCart(
    productCode: string,
    quantity: number,
    numberOfEntriesBeforeAdd: number,
    storeName?: string
  ) {
    const newEvent = new UigCartUiEventAddToCart();
    newEvent.productCode = productCode;
    newEvent.quantity = quantity;
    newEvent.numberOfEntriesBeforeAdd = this.numberOfEntriesBeforeAdd;
    newEvent.pickupStoreName = storeName;
    newEvent.entry$ = this.activeCartService.getLastEntry(this.productCode);
    newEvent.cart$ = this.activeCartService.getActive();
    newEvent.loaded$ = this.activeCartService.isStable();
    newEvent.quantity = this.quantity;
    return newEvent;
  }

  public addToCart() {
    const quantity = this.addToCartForm.get('quantity').value;
    if (!this.productCode || quantity <= 0) {
      return;
    }
    this.activeCartService
      .getEntries()
      .pipe(take(1))
      .subscribe((entries) => {
        this.numberOfEntriesBeforeAdd = entries.length;
        this.activeCartService.addEntry(this.productCode, quantity, null,false);
        this.eventService.dispatch(
          this.createCartUiEventAddToCart(
            this.productCode,
            quantity,
            entries.length,
            this.pickupStore
          )
        );
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.userSubscription.unsubscribe();
  }
}
